"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CreaseFace_1 = require("../core/CreaseFace");
// AdobePatentID="P8499-US-ORG1"
/**
 * A helper class used to represent a face for analysis.
 * @private
 */
class MetaFace extends CreaseFace_1.CreaseFace {
    constructor(index, face, edgeLoops) {
        super(index, edgeLoops);
        this._face = face;
        this._isTab = false;
        this._isGusset = false;
        this._area = face.area;
        this._isDestroyed = false;
    }
    /**
     * Gets the CreaseFace that this MetaFace wraps.
     * @returns {CreaseFace} A CreaseFace.
     */
    get face() {
        return this._face;
    }
    get isTab() {
        return this._isTab;
    }
    set isTab(state) {
        if (state === false) {
            // If we are unmarking a tab, check that this face is not in edge.tabFaces
            // of any adjacent edges.
            // In this case, the face must be a tab.
            for (let i = 0; i < this.edgeLoops[0].edgeRefs.length; i++) {
                const edgeRef = this.edgeLoops[0].edgeRefs[i];
                if (edgeRef.leftFace !== this) {
                    return;
                }
            }
        }
        this._isTab = state;
    }
    get area() {
        return this._area;
    }
    get isGusset() {
        return this._isGusset;
    }
    set isGusset(state) {
        this._isGusset = state;
    }
    get isDestroyed() {
        return this._isDestroyed;
    }
    get incidentFaces() {
        return super.incidentFaces;
    }
    get nonTabIncidentFaces() {
        return this.incidentFaces.filter(face => !face.isTab);
    }
    get vertexLoops() {
        return super.vertexLoops;
    }
    /**
     * Remove this face from MetaCrease, updates neighboring vertices and edges accordingly.
     */
    remove() {
        this.edgeLoops.forEach((loop) => {
            loop.edgeRefs.forEach((edgeRef) => {
                edgeRef.edge.removeFace(this);
            });
        });
        this.vertexLoops.forEach((loop) => {
            loop.forEach((vertex) => {
                vertex.removeFace(this);
            });
        });
        this.destroy();
    }
    // collapse(): void {
    //     // Check that this face should be collapsed.
    //     if (this.edgeLoops.length > 2) {
    //         throw new Error('Cannot collapse MetaFace with > 2 boundary edges.');
    //     }
    //     this.remove();
    // }
    /**
     * Reverse an edge in this face.
     * This should only be called by MetaEdge._reverse().
     * @private
     * @param {MetaEdge} edge A MetaEdge to reverse.
     */
    reverseEdge(edge) {
        this.edgeLoops.forEach((loop) => {
            loop.edgeRefs.forEach((edgeRef) => {
                if (edgeRef.edge === edge) {
                    edgeRef._reverse();
                }
            });
        });
    }
    /**
     * Replace an edge in this face.
     * This should only be called by MetaEdge.merge().
     * @private
     * @param {MetaEdge} oldEdge Old edge being removed.
     * @param {MetaEdge} newEdge New edge replacing old.
     */
    replaceEdge(oldEdge, newEdge) {
        this.edgeLoops.forEach((loop) => {
            loop.edgeRefs.forEach((edgeRef) => {
                if (edgeRef.edge === oldEdge) {
                    edgeRef._replaceEdge(newEdge);
                }
            });
        });
    }
    /**
     * Remove an edge in this face.
     * This should only be called by MetaEdge.collapse().
     * @private
     * @param {MetaEdge} edge A MetaEdge to remove.
     */
    removeEdge(edge) {
        const removedEdgeRefs = [];
        this.edgeLoops.forEach((loop) => {
            for (let i = loop.edgeRefs.length - 1; i >= 0; i--) {
                const edgeRef = loop.edgeRefs[i];
                if (edgeRef.edge === edge) {
                    removedEdgeRefs.push(edgeRef);
                    loop.edgeRefs.splice(i, 1);
                }
            }
        });
        // Remove any lingering pointers.
        removedEdgeRefs.forEach((edgeRef) => {
            edgeRef.destroy();
        });
    }
    toString() {
        return `${this._face.index}`;
    }
    destroy() {
        delete this._face;
        delete this._index;
        delete this._edgeLoops;
        delete this._isTab;
        this._isDestroyed = true;
    }
}
exports.MetaFace = MetaFace;
//# sourceMappingURL=MetaFace.js.map